export const services = [
  {
    slug: 'website-development',
    title: 'Website Development',
    headline: 'Website Development Company in Satara',
    short:
      'Fast, secure, mobile-responsive and SEO-optimized websites built to generate leads and grow your business.',
    description:
      'We build fast, secure, mobile-responsive, and SEO-optimized websites designed to generate leads, improve online visibility, and grow your business. Every website is developed with modern technology, optimized performance, and a Google-friendly structure.',
    image: '/services/service-website.png',
    icon: 'Globe',
    color: 'blue',
    seoTitle: 'Website Development Company in Satara | Growmore IT Services',
    seoDescription:
      'Website development company in Satara for corporate, business and e-commerce websites. Website design and web development services across Maharashtra and India.',
    seoKeywords:
      'Website Development Company in Satara, Web Development Company in Satara, Website Design Company in Satara, Website Development Services in Satara, Corporate Website Development, E-Commerce Website Development, Business Website Development, Website Development Company in Maharashtra, Web Development Company in India, Growmore IT Services',
    faqs: [
      {
        q: 'Which is the best website development company in Satara?',
        a: 'Growmore IT Services is a website development company in Satara offering website design, corporate websites, business websites and e-commerce website development for clients across Maharashtra and India.'
      },
      {
        q: 'Do you provide corporate and business website development?',
        a: 'Yes. We build corporate website development and business website development projects with SEO structure, mobile design, enquiry forms and admin access.'
      },
      {
        q: 'Can you develop an e-commerce website in Satara?',
        a: 'Yes. Our e-commerce website development covers catalogs, payments, Shopify, WooCommerce and custom stores for local and nationwide brands.'
      },
      {
        q: 'Are you a web development company in Maharashtra and India?',
        a: 'We are based in Satara and deliver website development services in Satara, Maharashtra and India from one team — design, development and go-live support.'
      }
    ],
    sections: [
      {
        title: 'What We Offer',
        items: [
          'Corporate Business Website',
          'Company Profile Website',
          'E-Commerce Website',
          'Shopify & WooCommerce Store',
          'Portfolio Website',
          'Landing Page Development',
          'Custom Web Portal',
          'Government Portal Development',
          'School & College Website',
          'Hospital & Clinic Website',
          'Hotel & Restaurant Website',
          'Real Estate Website',
          'Blog & News Portal',
          'Membership Portal',
          'Custom Admin Dashboard'
        ]
      },
      {
        title: 'Website Features Included',
        items: [
          'Responsive Mobile Design',
          'SEO-Friendly Structure',
          'Lightning Fast Loading',
          'SSL Security',
          'WhatsApp Integration',
          'Contact Forms',
          'Google Maps Integration',
          'Payment Gateway Integration',
          'Admin Panel',
          'Analytics Integration',
          'Multi-Language Support',
          'Hosting & Domain Setup'
        ]
      }
    ],
    seoLine:
      'Growmore is a website development company in Satara and a web development company in Satara for website design, corporate website development, e-commerce website development and business website development in Maharashtra and India.'
  },
  {
    slug: 'mobile-app-development',
    title: 'Mobile Application Development',
    headline: 'Mobile App Development Company in Satara',
    short:
      'Secure, scalable Android, iOS, Flutter and React Native apps with modern UI/UX and cloud backends.',
    description:
      'We develop secure, scalable mobile applications with modern UI/UX and cloud-based backend architecture for businesses of every size — from startups to enterprises across India.',
    image: '/services/service-mobile.png',
    icon: 'DeviceMobile',
    color: 'purple',
    seoTitle: 'Mobile App Development Company in Satara | Growmore IT Services',
    seoDescription:
      'Mobile app development company in Satara for Android, iOS, Flutter and React Native. Custom mobile app development across Maharashtra and India.',
    seoKeywords:
      'Mobile App Development Company in Satara, Mobile Application Development Company in Satara, Android App Development Company in Satara, iOS App Development Company in Satara, Flutter App Development Company in Satara, React Native App Development, Custom Mobile App Development, Mobile App Development Company in Maharashtra, Mobile App Development Company in India, Growmore IT Services',
    faqs: [
      {
        q: 'Is Growmore a mobile app development company in Satara?',
        a: 'Yes. Growmore IT Services is a mobile application development company in Satara building Android, iOS, Flutter and React Native apps for businesses in Maharashtra and India.'
      },
      {
        q: 'Do you offer Android and iOS app development in Satara?',
        a: 'We are an Android app development company in Satara and an iOS app development company in Satara, plus Flutter app development for one codebase on both stores.'
      },
      {
        q: 'Do you build Flutter and React Native apps?',
        a: 'Yes. Flutter app development and React Native app development are used when you want custom mobile app development that ships on Android and iOS together.'
      },
      {
        q: 'Can a Satara team deliver apps across India?',
        a: 'Yes. We work as a mobile app development company in Maharashtra and a mobile app development company in India — local meetings in Satara, delivery nationwide.'
      }
    ],
    sections: [
      {
        title: 'App Development Services',
        items: [
          'Android App Development',
          'iOS App Development',
          'Flutter App Development',
          'React Native App Development',
          'Business Mobile Apps',
          'E-Commerce Mobile Apps',
          'Delivery Apps',
          'Attendance Apps',
          'CRM Apps',
          'ERP Mobile Apps',
          'Healthcare Apps',
          'Education Apps',
          'Real Estate Apps',
          'GPS Tracking Apps',
          'Customer Portal Apps'
        ]
      },
      {
        title: 'App Features',
        items: [
          'Push Notifications',
          'Login & OTP Authentication',
          'Payment Gateway',
          'QR Code Integration',
          'WhatsApp Integration',
          'Cloud Database',
          'API Integration',
          'Admin Dashboard',
          'Offline & Online Sync'
        ]
      }
    ],
    seoLine:
      'Choose a mobile app development company in Satara for Android, iOS, Flutter and React Native — custom mobile app development for Maharashtra and India.'
  },
  {
    slug: 'custom-software-erp',
    title: 'Custom Software & ERP',
    headline: 'Software Development Company in Satara',
    short:
      'Enterprise-grade ERP and custom software tailored to your workflow, data, and productivity goals.',
    description:
      'We develop enterprise-grade software tailored to your business workflow, helping organizations automate operations, manage data, and improve productivity with role-based access and real-time reporting.',
    image: '/services/service-erp.png',
    icon: 'Database',
    color: 'orange',
    seoTitle: 'Software & ERP Development Company in Satara | Growmore',
    seoDescription:
      'Software development company in Satara for custom software, ERP, inventory, billing and accounting software. Custom ERP development across Maharashtra and India.',
    seoKeywords:
      'Software Development Company in Satara, Custom Software Development Company in Satara, ERP Software Development Company in Satara, Custom ERP Development, ERP Software Company in Satara, Business Software Development, Inventory Management Software, Billing Software Development, Accounting Software Development, Custom Software Development Company in Maharashtra, Software Development Company in India, Growmore IT Services',
    faqs: [
      {
        q: 'Are you a software development company in Satara?',
        a: 'Yes. Growmore is a software development company in Satara and a custom software development company in Satara for ERP, inventory, billing and accounting systems.'
      },
      {
        q: 'Do you also build ERP software in Satara?',
        a: 'We are an ERP software development company in Satara offering custom ERP development, inventory management software, billing software development and accounting software development.'
      },
      {
        q: 'What business software can you develop?',
        a: 'Business software development includes sales, purchase, inventory, GST billing, payroll, multi-branch reports and role-based admin — built around your process.'
      },
      {
        q: 'Do you serve clients outside Satara?',
        a: 'Yes. We work as a custom software development company in Maharashtra and a software development company in India, with the build team based in Satara.'
      }
    ],
    sections: [
      {
        title: 'ERP & Software Solutions',
        items: [
          'Inventory Management Software',
          'Billing Software (GST)',
          'Accounting Software',
          'CRM Software',
          'HR & Payroll Software',
          'Attendance Management Software',
          'Manufacturing ERP',
          'Hospital Management Software',
          'Pathology Lab Software',
          'School ERP',
          'College ERP',
          'Hotel Management Software',
          'Warehouse Management Software',
          'Retail POS Software',
          'Finance & Cashbook Software'
        ]
      },
      {
        title: 'Business Automation Modules',
        items: [
          'Sales Management',
          'Purchase Management',
          'Customer Management',
          'Employee Management',
          'Vendor Management',
          'Reports & Analytics',
          'Dashboard',
          'Role-Based Login',
          'Data Backup',
          'Multi-Branch Management'
        ]
      }
    ],
    seoLine:
      'Growmore is a software development company in Satara for custom software, ERP software, inventory management software, billing software development and accounting software across Maharashtra and India.'
  },
  {
    slug: 'ai-automation',
    title: 'AI Automation Solutions',
    headline: 'AI Automation Company in Satara',
    short:
      'AI chatbots, WhatsApp bots and workflow automation that handle leads, support and follow-ups around the clock.',
    description:
      'Automate customer communication, sales follow-ups, business workflows, and repetitive operations using AI-powered automation systems developed by Growmore IT Services.',
    image: '/services/service-ai.png',
    icon: 'Brain',
    color: 'cyan',
    seoTitle: 'AI Automation Company in Satara | AI Solutions | Growmore',
    seoDescription:
      'AI automation company in Satara for AI chatbots, WhatsApp AI chatbots, workflow automation and business process automation across Maharashtra and India.',
    seoKeywords:
      'AI Automation Company in Satara, AI Automation Services in Satara, AI Solutions Company in Satara, AI Chatbot Development, AI WhatsApp Chatbot, WhatsApp AI Chatbot, Business Process Automation, AI Business Automation, Workflow Automation Services, AI Automation Company in Maharashtra, AI Automation Services in India, Growmore IT Services',
    faqs: [
      {
        q: 'Is Growmore an AI automation company in Satara?',
        a: 'Yes. Growmore is an AI automation company in Satara and an AI solutions company in Satara for chatbots, WhatsApp AI and workflow automation.'
      },
      {
        q: 'What AI automation services do you provide?',
        a: 'AI automation services in Satara include AI chatbot development, AI WhatsApp chatbot, WhatsApp AI chatbot, business process automation and AI business automation.'
      },
      {
        q: 'Do you build WhatsApp AI chatbots?',
        a: 'Yes. We build AI WhatsApp chatbots and WhatsApp AI chatbots that answer FAQs, qualify leads and hand over to your team when needed.'
      },
      {
        q: 'Do you offer workflow automation beyond Satara?',
        a: 'Workflow automation services run for clients across Maharashtra and India. We are an AI automation company in Maharashtra offering AI automation services in India.'
      }
    ],
    sections: [
      {
        title: 'WhatsApp AI Automation',
        items: [
          'AI WhatsApp Chatbot',
          'Auto Reply Bot',
          'FAQ Automation',
          'Lead Qualification Bot',
          'Order Status Bot',
          'Customer Support Bot',
          'Appointment Booking Bot',
          'Payment Reminder Bot'
        ]
      },
      {
        title: 'Business Workflow Automation',
        items: [
          'CRM Automation',
          'Lead Distribution',
          'Follow-up Automation',
          'Invoice Automation',
          'Email Automation',
          'Document Generation',
          'Approval Workflow',
          'Reminder Automation',
          'Employee Workflow Automation'
        ]
      },
      {
        title: 'AI Chatbot Solutions',
        items: [
          'Website AI Chatbot',
          'WhatsApp AI Assistant',
          'Messenger Chatbot',
          'Multi-language Chatbot',
          'Knowledge Base Chatbot',
          'Product Recommendation Bot'
        ]
      },
      {
        title: 'AI Features',
        items: [
          'Natural Language Conversations',
          'Multi-Language Support',
          'AI Responses',
          'Human Agent Handover',
          'Analytics Dashboard',
          'Customer Journey Tracking'
        ]
      }
    ],
    seoLine:
      'Growmore is an AI automation company in Satara offering AI automation services, AI chatbot development, WhatsApp AI chatbots and workflow automation services in Maharashtra and India.'
  },
  {
    slug: 'whatsapp-business-automation',
    title: 'WhatsApp Business Automation',
    headline: 'WhatsApp Business Automation in Satara',
    short:
      'ChatNex — official WhatsApp Business API for campaigns, live chat, AI bots, OTP and CRM integrations.',
    description:
      'ChatNex by Growmore IT Services is a complete WhatsApp Business Automation platform built for sales, marketing, customer support, and business communication using the Official WhatsApp Business API.',
    image: '/services/service-whatsapp.png',
    icon: 'WhatsappLogo',
    color: 'green',
    seoTitle: 'WhatsApp Business Automation in Satara | WhatsApp API | Growmore',
    seoDescription:
      'WhatsApp Business Automation in Satara with official WhatsApp Business API, ChatNex inbox, WhatsApp chatbot, bulk messaging and CRM integration.',
    seoKeywords:
      'WhatsApp Business Automation in Satara, WhatsApp Automation Services in Satara, WhatsApp API Services in Satara, WhatsApp Business API, WhatsApp API Integration, WhatsApp Marketing Automation, WhatsApp Chatbot, WhatsApp Bulk Messaging, WhatsApp CRM Integration, WhatsApp Automation Company in Maharashtra, WhatsApp API Services in India, ChatNex, Growmore IT Services',
    faqs: [
      {
        q: 'Do you offer WhatsApp Business Automation in Satara?',
        a: 'Yes. Growmore provides WhatsApp Business Automation in Satara through ChatNex — official WhatsApp Business API, live inbox, templates and green tick setup.'
      },
      {
        q: 'What WhatsApp API services are available in Satara?',
        a: 'WhatsApp API services in Satara include WhatsApp API integration, WhatsApp marketing automation, WhatsApp chatbot, WhatsApp bulk messaging and WhatsApp CRM integration.'
      },
      {
        q: 'Is this official WhatsApp Business API or unofficial tools?',
        a: 'ChatNex uses the official WhatsApp Business API from Meta — not unofficial bulk APKs — with approved templates, OTP and a shared team inbox.'
      },
      {
        q: 'Do you serve clients outside Satara?',
        a: 'Yes. We work as a WhatsApp automation company in Maharashtra and provide WhatsApp API services in India, with local support from Satara.'
      }
    ],
    sections: [
      {
        title: 'Official WhatsApp API Setup',
        items: [
          'Business Verification',
          'Embedded Signup',
          'WhatsApp Number Migration',
          'WhatsApp Coexistence',
          'Green Tick Assistance'
        ]
      },
      {
        title: 'WhatsApp Automation',
        items: [
          'Bulk WhatsApp Campaigns',
          'Promotional Campaigns',
          'Transactional Messages',
          'Utility Messages',
          'OTP Messages',
          'Authentication Messages'
        ]
      },
      {
        title: 'Customer Engagement',
        items: [
          'Shared Team Inbox',
          'Live Chat',
          'AI Chatbot',
          'Auto Replies',
          'Template Messages',
          'Contact Management',
          'Multi-Agent Support'
        ]
      },
      {
        title: 'Campaign Management',
        items: [
          'Broadcast Campaigns',
          'Audience Segmentation',
          'Click Tracking',
          'Delivery Reports',
          'Read Reports',
          'Campaign Analytics'
        ]
      },
      {
        title: 'Integrations',
        items: [
          'WooCommerce Integration',
          'Shopify Integration',
          'Website Integration',
          'CRM Integration',
          'API Integration',
          'Webhooks',
          'Payment Integration'
        ]
      },
      {
        title: 'ChatNex Features',
        items: [
          'Official Meta WhatsApp API',
          'Unlimited Campaigns',
          'AI Automation',
          'Live Chat',
          'Flow Builder',
          'REST API',
          'Analytics Dashboard',
          'Enterprise Security'
        ]
      }
    ],
    productUrl: 'https://chatnex.in',
    productName: 'ChatNex',
    seoLine:
      'Growmore offers WhatsApp Business Automation in Satara — WhatsApp API services, WhatsApp chatbot, WhatsApp bulk messaging and WhatsApp CRM integration via ChatNex for Maharashtra and India.'
  },
  {
    slug: 'ivr-ai-voice-calling',
    title: 'IVR & AI Voice Calling',
    headline: 'IVR Service Provider in Satara',
    short:
      'IVR menus, AI voice campaigns, toll-free numbers and cloud telephony so you never miss a customer call.',
    description:
      'Never miss a customer call with IVR systems, AI Voice Calling, Toll-Free Numbers, and Cloud Telephony solutions built for sales, support, and reminders.',
    image: '/services/service-ivr.png',
    icon: 'PhoneCall',
    color: 'teal',
    seoTitle: 'IVR & AI Voice Calling Services in Satara | Growmore IT Services',
    seoDescription:
      'IVR service provider in Satara for IVR services, cloud telephony, virtual numbers, AI voice calling and automated voice calling across Maharashtra and India.',
    seoKeywords:
      'IVR Service Provider in Satara, IVR Services in Satara, Cloud Telephony Services in Satara, IVR Solutions for Business, Virtual Number Service, Business IVR System, AI Voice Calling Services, AI Voice Bot, Automated Voice Calling, Cloud Telephony Company in Maharashtra, IVR Service Provider in India, Growmore IT Services',
    faqs: [
      {
        q: 'Who is an IVR service provider in Satara?',
        a: 'Growmore IT Services is an IVR service provider in Satara offering IVR services, business IVR systems, virtual number service and cloud telephony services in Satara.'
      },
      {
        q: 'Do you provide AI voice calling and AI voice bots?',
        a: 'Yes. AI voice calling services, AI voice bots and automated voice calling handle reminders, surveys, lead verification and after-hours greetings.'
      },
      {
        q: 'Can I get a virtual number and cloud telephony?',
        a: 'We set up virtual number service, cloud telephony services in Satara, call recording, click-to-call and CRM calling for your team.'
      },
      {
        q: 'Do you work outside Satara?',
        a: 'Yes. We operate as a cloud telephony company in Maharashtra and an IVR service provider in India, with local support from Satara.'
      }
    ],
    sections: [
      {
        title: 'IVR Services',
        items: [
          'Multi-Level IVR',
          'Press 1 / Press 2 Menu',
          'Department Routing',
          'Call Transfer',
          'Business Greeting Setup',
          'Holiday IVR',
          'After Hours IVR'
        ]
      },
      {
        title: 'AI Voice Calling Services',
        items: [
          'AI Voice Calling Campaign',
          'AI Appointment Reminder Calls',
          'AI Payment Reminder Calls',
          'AI Feedback Collection Calls',
          'AI Survey Calling',
          'AI Lead Verification Calls',
          'AI Customer Support Calls',
          'AI Follow-up Calls'
        ]
      },
      {
        title: 'Cloud Telephony',
        items: [
          'Toll-Free Number',
          'Virtual Mobile Number',
          'Cloud Calling',
          'Click-to-Call',
          'Call Recording',
          'Call Analytics',
          'Agent Dashboard',
          'CRM Calling Integration'
        ]
      },
      {
        title: 'Voice Broadcasting',
        items: [
          'Bulk Voice Calls',
          'Promotional Voice Campaign',
          'Festival Greetings',
          'Emergency Alerts',
          'Payment Reminder Voice Calls'
        ]
      }
    ],
    seoLine:
      'Growmore is an IVR service provider in Satara for IVR services, cloud telephony, virtual numbers, AI voice calling services and automated voice calling in Maharashtra and India.'
  },
  {
    slug: 'bulk-sms',
    title: 'Bulk SMS Services',
    headline: 'Bulk SMS Service Provider in Satara',
    short:
      'Promotional, transactional, OTP and alert SMS across India with DLT support, sender ID and delivery reports.',
    description:
      'Send promotional, transactional, OTP, and alert SMS instantly across India with delivery reports and campaign analytics from a reliable SMS gateway.',
    image: '/services/service-sms.png',
    icon: 'ChatTeardropText',
    color: 'indigo',
    seoTitle: 'Bulk SMS Service Provider in Satara | DLT SMS Services | Growmore',
    seoDescription:
      'Bulk SMS service provider in Satara for promotional SMS, transactional SMS, OTP SMS and DLT SMS services across Maharashtra and India.',
    seoKeywords:
      'Bulk SMS Service Provider in Satara, Bulk SMS Services in Satara, Bulk SMS Provider in Satara, Promotional SMS Services, Transactional SMS Services, OTP SMS Service, DLT SMS Services, SMS Marketing Services, Bulk SMS Service Provider in Maharashtra, Bulk SMS Service Provider in India, Growmore IT Services',
    faqs: [
      {
        q: 'Who is a bulk SMS service provider in Satara?',
        a: 'Growmore IT Services is a bulk SMS service provider in Satara and a bulk SMS provider in Satara for promotional, transactional and OTP routes with DLT support.'
      },
      {
        q: 'Do you offer DLT SMS and OTP SMS services?',
        a: 'Yes. DLT SMS services, OTP SMS service, sender ID setup and API integration are included with bulk SMS services in Satara.'
      },
      {
        q: 'Can I run promotional SMS and SMS marketing?',
        a: 'Promotional SMS services and SMS marketing services cover festival offers, launches and campaigns with delivery reports. Transactional SMS services cover invoices, orders and bookings.'
      },
      {
        q: 'Do you send SMS outside Satara?',
        a: 'Yes. We work as a bulk SMS service provider in Maharashtra and a bulk SMS service provider in India with nationwide delivery reports.'
      }
    ],
    sections: [
      {
        title: 'Promotional SMS',
        items: ['Festival Offers', 'Marketing Campaigns', 'New Product Launch', 'Discount Campaigns']
      },
      {
        title: 'Transactional SMS',
        items: ['OTP SMS', 'Invoice SMS', 'Order Confirmation', 'Delivery Updates', 'Booking Confirmation']
      },
      {
        title: 'Utility SMS',
        items: [
          'Appointment Reminder',
          'Payment Reminder',
          'School Notifications',
          'Hospital Notifications',
          'Office Alerts'
        ]
      },
      {
        title: 'SMS Platform Features',
        items: [
          'DLT Registration Support',
          'Sender ID Setup',
          'Delivery Reports',
          'API Integration',
          'Contact Upload',
          'Scheduling',
          'Analytics Dashboard'
        ]
      }
    ],
    seoLine:
      'Growmore is a bulk SMS service provider in Satara for bulk SMS services, promotional SMS, transactional SMS, OTP SMS and DLT SMS services in Maharashtra and India.'
  },
  {
    slug: 'digital-marketing-seo',
    title: 'Digital Marketing & SEO',
    headline: 'Digital Marketing Company in Satara',
    short:
      'Technical SEO, local SEO, Google Ads and social campaigns that improve rankings and bring quality leads.',
    description:
      'We help businesses improve Google rankings, generate quality leads, and increase online visibility using data-driven digital marketing strategies.',
    image: '/services/service-marketing.png',
    icon: 'ChartLineUp',
    color: 'pink',
    seoTitle: 'Digital Marketing & SEO Company in Satara | Growmore IT Services',
    seoDescription:
      'Digital marketing company in Satara and SEO company in Satara for local SEO, Google Ads, social media marketing and search engine optimization in Maharashtra and India.',
    seoKeywords:
      'Digital Marketing Company in Satara, Digital Marketing Services in Satara, SEO Company in Satara, SEO Services in Satara, Local SEO Services in Satara, Google Ads Management, Social Media Marketing, Search Engine Optimization Services, Digital Marketing Agency in Maharashtra, Digital Marketing Company in India, SEO Company in India, Growmore IT Services',
    faqs: [
      {
        q: 'Which digital marketing company in Satara should I hire?',
        a: 'Growmore IT Services is a digital marketing company in Satara offering digital marketing services, SEO services, Google Ads management and social media marketing.'
      },
      {
        q: 'Are you also an SEO company in Satara?',
        a: 'Yes. We are an SEO company in Satara with local SEO services in Satara, on-page SEO, technical SEO and search engine optimization services for Maps and Google Search.'
      },
      {
        q: 'Do you manage Google Ads and social media?',
        a: 'Google Ads management and social media marketing cover Search, Meta, Instagram, YouTube and LinkedIn campaigns aimed at leads, not vanity traffic.'
      },
      {
        q: 'Do you work outside Satara?',
        a: 'Yes. We operate as a digital marketing agency in Maharashtra, a digital marketing company in India and an SEO company in India, with the team based in Satara.'
      }
    ],
    sections: [
      {
        title: 'Technical SEO',
        items: [
          'Website Audit',
          'Speed Optimization',
          'Schema Markup',
          'XML Sitemap',
          'Robots.txt',
          'SSL Optimization',
          'Mobile Optimization'
        ]
      },
      {
        title: 'On-Page SEO',
        items: [
          'Keyword Research',
          'Meta Titles',
          'Meta Descriptions',
          'Heading Optimization',
          'Internal Linking',
          'Image SEO',
          'Content Optimization'
        ]
      },
      {
        title: 'Local SEO',
        items: [
          'Google Business Profile Setup',
          'Google Maps Ranking',
          'Review Management',
          'Local Citation Building',
          'Local Keyword Optimization'
        ]
      },
      {
        title: 'Off-Page SEO',
        items: [
          'High Quality Backlinks',
          'Guest Posting',
          'Business Directory Submission',
          'Brand Mentions'
        ]
      },
      {
        title: 'Digital Marketing Services',
        items: [
          'Google Ads',
          'Meta Ads',
          'Instagram Marketing',
          'Facebook Marketing',
          'WhatsApp Marketing',
          'YouTube Marketing',
          'LinkedIn Marketing',
          'Email Marketing',
          'Content Marketing',
          'Lead Generation Campaigns'
        ]
      },
      {
        title: 'Reporting',
        items: [
          'Keyword Ranking Reports',
          'Traffic Reports',
          'Lead Reports',
          'Conversion Reports',
          'Monthly SEO Reports'
        ]
      }
    ],
    seoLine:
      'Growmore is a digital marketing company in Satara and an SEO company in Satara for local SEO, Google Ads management, social media marketing and search engine optimization in Maharashtra and India.'
  },
  {
    slug: 'cyber-security',
    title: 'Cyber Security Services',
    headline: 'Cyber Security Company in Satara',
    short:
      'VAPT, penetration testing, malware removal, firewalls and 24×7 monitoring to protect websites, servers and data.',
    description:
      'Growmore is a cyber security company in Satara offering cyber security services, VAPT services in Satara, penetration testing, website security audit, malware removal services and network security services for businesses across Maharashtra and India.',
    image: '/services/service-security.png',
    icon: 'ShieldCheck',
    color: 'red',
    seoTitle: 'Cyber Security Company in Satara | VAPT & Security Services | Growmore',
    seoDescription:
      'Cyber security company in Satara for VAPT services, penetration testing, website security audit and malware removal across Maharashtra and India.',
    seoKeywords:
      'Cyber Security Company in Satara, Cyber Security Services in Satara, Cybersecurity Company in Satara, VAPT Services in Satara, VAPT Testing Company, Penetration Testing Services, Website Security Audit, Malware Removal Services, Network Security Services, Cyber Security Company in Maharashtra, Cyber Security Services in India, Growmore IT Services',
    faqs: [
      {
        q: 'Is Growmore a cyber security company in Satara?',
        a: 'Yes. Growmore is a cyber security company in Satara and a cybersecurity company in Satara offering VAPT, website security audit and network security services.'
      },
      {
        q: 'Do you provide VAPT services in Satara?',
        a: 'We are a VAPT testing company offering VAPT services in Satara, penetration testing services and website security audits for apps, sites and servers.'
      },
      {
        q: 'Can you remove malware and secure the network?',
        a: 'Malware removal services, firewalls, server hardening and network security services protect websites, emails and business data after the first audit.'
      },
      {
        q: 'Do you work outside Satara?',
        a: 'Yes. We operate as a cyber security company in Maharashtra with cyber security services in India, and local meetings in Satara.'
      },
      {
        q: 'What is included in a website security audit?',
        a: 'A website security audit checks vulnerabilities, SSL, access control, malware and server hardening, then we share a fix list with severity so your site and data stay protected.'
      }
    ],
    sections: [
      {
        title: 'Security Services',
        items: [
          'Website Security Audit',
          'VAPT Testing',
          'Penetration Testing',
          'Malware Removal',
          'Firewall Setup',
          'SSL Installation',
          'Server Hardening',
          'Email Security',
          'Data Backup Solutions',
          'Security Monitoring',
          'Vulnerability Assessment',
          'Security Consultation'
        ]
      },
      {
        title: 'Security Features',
        items: [
          '24×7 Monitoring',
          'Secure Hosting',
          'Backup Automation',
          'Access Control',
          'Threat Protection'
        ]
      }
    ],
    seoLine:
      'Growmore is a cyber security company in Satara for VAPT services, penetration testing, website security audit, malware removal and network security services in Maharashtra and India.'
  }
];

export const getServiceBySlug = (slug) => services.find((item) => item.slug === slug);
